module.exports = __webpack_public_path__ + "img/tropicales.6ff8bd52.png";